export default __webpack_public_path__ + "static/cashflow_new_9-9727e6ceca5a343e6f1d2d1467a16cdf.jpg";